import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 100 100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F15A29",
  d: "M72.095 12.052 63.043 3h-.135v15.81l9.187 9.187zM72.096 33.691l-8.625-8.625-14.135-14.134L13 47.269v20.5a14.647 14.647 0 0 0 14.65 14.648h44.446V52.473l-9.188-9.189V73.23H29.235a7.046 7.046 0 0 1-7.05-7.048V51.07l24.258-24.245 2.893-2.895 13.572 13.567 9.188 9.188 4.716 4.717v36.202L86 96.792v-49.19z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logo-minimal"}) } }